export default __webpack_public_path__ + "assets/img/avatar-13.8369892.png";